import React, { FC } from 'react'
import ScheduleFilters from './ScheduleFilters'
import { SchedulerFiltersFormName, useScheduler } from '../../context/SchedulerContext'

const ScheduleFiltersContainer: FC = () => {
	const { handleFilters, nbDays, selectedRessources } = useScheduler()

	return <ScheduleFilters
		onSubmit={handleFilters}
		nbDays={nbDays}
		selectedRessources={selectedRessources}
		form={SchedulerFiltersFormName}
	/>
}

export default ScheduleFiltersContainer

